import React from 'react';
import ReadSaleData from './Read';
import WriteSaleData from './Write';

export default function SaleData(props) {
  const { isUpdate, inputChange, dataProduct } = props; //data Products

  return isUpdate ? (
    <WriteSaleData inputChange={inputChange} dataProduct={dataProduct} />
  ) : (
    <ReadSaleData dataProduct={dataProduct} />
  );
}
